;(function() {
  'use strict'

  angular
    .module('ATMGurus')
    .controller('RegisterController', RegisterController)

  RegisterController.$inject = [
    'ApiCustomer',
    '$location',
    'Auth',
    'ErrorService',
    '$state',
    '$scope',
    '$rootScope',
    '$timeout'
  ]

  function RegisterController(
    Customer,
    $location,
    Auth,
    ErrorService,
    $state,
    $scope,
    $rootScope,
    $timeout
  ) {
    var _this = this

    this.pristineStatus = this.status = {
      action: undefined,
      loading: false,
      error: false,
      errorDetails: undefined,
      message: undefined,
      checkingCompany: undefined,
      canRegister: false,
      needAddress: true,
      customerNumberValid: false,
      success: false
    }

    this.email = undefined
    this.data = {
      password: undefined,
      password_confirmation: undefined,
      token: undefined,
      email: undefined
    }
    // default endpoint, we swap it if needed
    this.endpoint = 'customer/register'
    // token for password reset
    this.token = $state.params.token

    /**
     *	Handle title + meta desc
     */
    $rootScope.$emit('meta.refreshed', {
      page_title: 'ATMGurus User Services',
      description: 'Login, register, password reset'
    })

    // if we're coming back from activation
    if ($location.search().activate) {
      this.status.loading = true
      $scope.$emit('modal.open', {
        data: { message: 'We are activating your account please wait.' }
      })
      Customer.activate($location.search().activate)
        .then(response => {
          this.status.loading = false
          this.status.message = response.data.data
          this.status.success = true
          $scope.$emit('modal.close')
        })
        .catch(response => {
          this.status.loading = false
          $scope.$emit('modal.close')
          this.status.success = true
          this.status.error = true
          this.status.message = 'Error: ' + response.data.error
        })
    }

    // if we're coming back from verification
    if ($location.search().verify) {
      $scope.$emit('modal.open', {
        data: { message: 'We are verifying your email address, please wait.' }
      })
      Customer.verify($location.search().verify)
        .then(response => {
          $scope.$emit('modal.close')
          this.status.message = response.data.data
          this.status.success = true
        })
        .catch(response => {
          $scope.$emit('modal.close')
          this.status.success = true
          this.status.error = true
          this.status.message = 'Error: ' + response.data.error
        })
    }

    var formInit = {
      country: { name: 'United States', code: 'US' },
      email: ''
    }

    this.countries = require('../../assets/lib/countries.json')

    this.formDetails = angular.copy(formInit)

    // phone number mask
    _this.mask = '( 999 ) - 999 - 9999'

    /**--------------------------------------------------------
     *	checkCompanyName
     *	check if company name is available
     --------------------------------------------------------*/

    $rootScope.$on('$stateChangeSuccess', function() {
      if (
        $state.current.name === 'userActions.register' &&
        $scope.$parent !== null
      ) {
        triggerUserLinkingModal()
      }
    })

    if ($state.current.name === 'userActions.register') {
      triggerUserLinkingModal()
    }

    function triggerUserLinkingModal() {
      if (
        !angular.isDefined($location.search().activate) &&
        !angular.isDefined($location.search().verify)
      ) {
        $scope.$emit('modal.open', {
          title: 'Link to existing customer',
          template: 'link_customer'
        })
      }
    }

    /**
     *	modals are on the maincontroller, to link it with this controller we need to fire it explicitly in the modal
     *	causing a new digest thus no link with this controller is available. events solves it in a barely bearable manner.
     */
    $rootScope.$on('customerLinked', (event, data) => {
      if (data.success) {
        this.formDetails.customer_number = data.customer_number
        this.endpoint = 'customer/register-user'
        this.status.canRegister = true
        this.status.needAddress = false
        this.status.customerNumberValid = true
      } else {
        if (typeof data.error === 'object') {
          this.status.message = 'Validation Error'
          this.status.errorDetails = data.error
        } else {
          this.status.message = data.error
        }
        this.status.error = true
        this.status.customerNumberValid = false
      }
      $timeout(() => {
        $rootScope.$emit('modal.close')
      }, 500)
      $scope.$digest()
    })

    /**
     *
     *	Submit form and add contact
     *
     */
    this.submit = function() {
      this.status.loading = true
      // $scope.$emit( "modal.open", { data: { message: "We are processing your request, please wait." }} )

      this.status.error = false
      this.status.errorDetails = undefined
      this.status.message = undefined
      this.status.success = false

      var data = angular.copy(this.formDetails)

      data.country = this.formDetails.country.code

      Customer.add(data, this.endpoint)
        .then(response => {
          this.status.loading = false
          // reset form + errors
          this.customerForm.$setPristine()
          this.customerForm.$setUntouched()
          this.formDetails = angular.copy(formInit)
          $scope.$emit('modal.close')
          this.status.message = response.data.data.message
          this.status.error = false
          this.status.success = true
          this.status.errorDetails = undefined
        })
        .catch(response => {
          this.status.loading = false
          $scope.$emit('modal.close')
          this.status.message = 'Validation Errors'
          this.status.error = true
          this.status.success = false
          this.status.errorDetails = response.data.error
        })
    }

    /**
     *
     *	Password recovery
     *
     *
     */
    this.requestPasswordReset = function() {
      this.status.loading = true
      ErrorService.reset('userActions')
      this.status.loading = true
      Auth.passwordRequest(_this.email)
        .then(message => {
          this.status = {
            loading: false,
            error: false,
            success: true,
            message: message
          }
        })
        .catch(message => {
          this.status = {
            loading: false,
            error: true,
            success: false,
            message: message
          }
        })
    }

    /**
     *	Reset Password
     */
    this.resetPassword = function() {
      var parms = {
        token: _this.token || undefined,
        email: _this.data.email || undefined,
        password: _this.data.p,
        password_confirmation: _this.data.p_confirm
      }

      return Auth.resetPassword(parms)
        .then(response => {
          this.status = {
            message: response.message,
            error: false,
            errorDetails: undefined
          }
        })
        .catch(reason => {
          this.status = {
            message: 'Error',
            error: true,
            errorDetails: reason.error
          }
        })
    }
  }
})()



// WEBPACK FOOTER //
// ./src/app/controllers/RegisterController.js